import { forwardRef } from 'react'

import Flex, { FlexProps } from './Flex'

type Props = Omit<FlexProps, 'direction'>
const VStack = forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  return <Flex direction="column" align="start" {...props} ref={ref} />
})

export default VStack
